import { render, staticRenderFns } from "./start-today-card.vue?vue&type=template&id=9dbc1374&scoped=true"
import script from "./start-today-card.vue?vue&type=script&lang=js"
export * from "./start-today-card.vue?vue&type=script&lang=js"
import style0 from "./start-today-card.vue?vue&type=style&index=0&id=9dbc1374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbc1374",
  null
  
)

export default component.exports